<template>
	<b-modal v-model="isShowPopup" dialog-class="modal-detail" @hidden="resetModal" scrollable :no-close-on-backdrop=true @ok="saveButtonAction" title="Save Confirmation - Download Process">
<!-- APP_DETAIL_HEADER -->
		<b-card>
			<b-col cols="12" lg="6">
					<b-form-group id="fieldset-job-id" label-cols-sm="4" label-cols-lg="3" label="" label-for="filter-job-id">
						{{ model != null ? model.jobId : "" }}
					</b-form-group>
					<b-form-group id="fieldset-function-id" label-cols-sm="4" label-cols-lg="3" label="Function Id" label-for="filter-function-id">
						{{ model != null ? model.functionId : "" }}
					</b-form-group>
					<b-form-group id="fieldset-file-name" label-cols-sm="4" label-cols-lg="3" label="" label-for="filter-file-name">
						{{ model != null ? model.fileName : "" }}
					</b-form-group>
					<b-form-group id="fieldset-start-time" label-cols-sm="4" label-cols-lg="3" label="Start Time" label-for="filter-start-time">
						{{ (model != null ? model.startTime : "") | moment("DD-MMM-YYYY HH:mm") }}
					</b-form-group>
					<b-form-group id="fieldset-end-time" label-cols-sm="4" label-cols-lg="3" label="End Time" label-for="filter-end-time">
						{{ (model != null ? model.endTime : "") | moment("DD-MMM-YYYY HH:mm") }}
					</b-form-group>
					<b-form-group id="fieldset-status" label-cols-sm="4" label-cols-lg="3" label="Status" label-for="filter-status">
						{{ model != null ? model.status : "" }}
					</b-form-group>
					<b-form-group id="fieldset-error-message" label-cols-sm="4" label-cols-lg="3" label="Error Message" label-for="filter-error-message">
						{{ model != null ? model.errorMessage : "" }}
					</b-form-group>
			</b-col>
		</b-card>
<!-- END_APP_DETAIL_HEADER -->
		<b-overlay :show="isBusy" no-wrap></b-overlay>
	</b-modal>
</template>
<script>
/*APP_DETAIL_IMPORT*/
import DownloadProcess from '@/models/DownloadProcess/DownloadProcess';
import DownloadProcessList from '@/models/DownloadProcess/DownloadProcessList';
import DownloadProcessFilter from '@/filters/DownloadProcess/DownloadProcessFilter';

import PopupRouterViewDetail from '@/components/PopupRouterViewDetail';
import AppInputDatetimepicker from '@/components/AppInputDatetimepicker';
import AppInputDatetimepickerRange from '@/components/AppInputDatetimepickerRange';
/*END_APP_DETAIL_IMPORT*/
export default {
	/*APP_DETAIL_PROP_DEFINITION*/
	props : ["openPopup", "model", "saveActionMethod", "resetMethod"],
	/*END_APP_DETAIL_PROP_DEFINITION*/
	components : {
	/*APP_DETAIL_PROP_DEFINITION*/
	PopupRouterViewDetail,AppInputDatetimepicker,AppInputDatetimepickerRange,
	/*APP_DETAIL_COMPONENTS_DEFINITION*/
},
	data() {
		return {
			fileupload: null,
			datas: Array(),
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			/*APP_DETAIL_PAGINATION*/
			/*END_APP_DETAIL_PAGINATION*/
			/*APP_DETAIL_FILTER*/
			filterDownloadProcess : null,
			/*END_APP_DETAIL_FILTER*/
			/*APP_DETAIL_PAGING_DEFINITION*/
			currentDownloadProcessPage : 1,
			downloadProcessPageSize: 10,
			/*END_APP_DETAIL_PAGING_DEFINITION*/
			/*APP_DETAIL_SORT_DEFINITION*/
			sortByDownloadProcess: '',
			sortDescDownloadProcess: '',
			/*END_APP_DETAIL_SORT_DEFINITION*/
			/*APP_DETAIL_VARIABLE_DEFINITION*/
			/*END_APP_DETAIL_VARIABLE_DEFINITION*/
			/*APP_DETAIL_OBJ_VARIABLE*/
			/*END_APP_DETAIL_OBJ_VARIABLE*/
		}
	},
	methods : {
		/*APP_DETAIL_GETDownloadProcess*/
		getDownloadProcess : async function(id) {
			this.isBusy = true;
			DownloadProcess.getData(this, id).then(result => { this.model = result; this.isBusy = false; }).catch(error => { this.isBusy = false; });
		},
		/*END_APP_DETAIL_GETDownloadProcess*/
		/*APP_DETAIL_COPYDATA*/
		copyDataAction(modelEvent) {
			this.$router.push({ name: 'downloadprocesscopydata', params: { id: this.modelId, copydata : 1 } })
		},
		/*END_APP_DETAIL_COPYDATA*/
		/*APP_DETAIL_SAVEBUTTONACTION*/
		saveButtonAction(modalEvent) {
			this.$emit("saveActionMethod", modalEvent);
		},
		/*END_APP_DETAIL_SAVEBUTTONACTION*/
		/*APP_DETAIL_RESETMODAL*/
		resetModal() {
			this.$emit('resetMethod'); 
		},
		/*END_APP_DETAIL_RESETMODAL*/
		/*APP_DETAIL_DISPLAYFILTER*/
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
			}
		},
		/*END_APP_DETAIL_DISPLAYFILTER*/
	},
	/*APP_DETAIL_BEFORE_MOUNT*/
	beforeMount() {
		this.filterDownloadProcess = new DownloadProcessFilter();
	},
	/*END_APP_DETAIL_BEFORE_MOUNT*/
	watch : {
	},
	/*APP_DETAIL_COMPUTED*/
	computed: {
		isShowPopup: {
			get: function(){
				if (this.openPopup) return true; 
				else return false; 
			},
			set: function(newValue){ }
		},
	}
	/*END_APP_DETAIL_COMPUTED*/
}
</script>
